<template>
    <div>
        <Modal v-model="visible" :title="title" width="460" class="my-modal top" :mask-closable="false" :footer-hide="true">
            <Form v-if="showPupUp" ref="form" :model="formData" class="full form" label-position="left">
                <FormItem prop="baseName" label="基本法" class="full">
                    <span>{{ formData.baseName }}</span>
                </FormItem>
                <FormItem prop="rankName" label="职级" class="full">
                    <span>{{ formData.rankName }}</span>
                </FormItem>
                <FormItem prop="checkDate" label="要计算的考核时间" :rules="$units.formRule.objRequired('请选择')">
                    <DatePicker transfer format="yyyy/MM" :options="options" type="month" v-model="formData.checkDate"
                        clearable placeholder="请选择">
                    </DatePicker>
                </FormItem>
                <FormItem prop="orgIds" :label="labelTitle" :rules="$units.formRule.arrRequired('请选择', 'change')">
                    <!-- <selectTree v-model="formData.orgIds" type="4" :multiple="true" ref="selectTreeRef"></selectTree> -->
                    <Select v-model="formData.orgIds" placeholder="请选择" clearable multiple transfer filterable>
                        <Option :value="org.id" v-for="org in orgList" :key="org.id">{{
                            org.fullName }}</Option>
                    </Select>
                </FormItem>
            </Form>

            <div class="ivu-modal-footer">
                <Button type="text" @click="visible = false">取消</Button>
                <Button type="primary" @click="save" :loading="loading">确认</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear'; //获取季度需要
dayjs.extend(quarterOfYear);
import filter from '@/api/filter';
import selectTree from '@/components/system/selectTree3';
export default {
    // type 1-晋升 0-维持
    props: ['type'],
    components: { selectTree },
    data() {
        return {
            options: {
                disabledDate(date) {
                    return true
                }
            },
            filter,
            visible: false,
            showPupUp: false,
            formData: {
                orgIds: [],
                checkDate: ''
            },
            orgList: [],
            loading: false,
            title: '',
            labelTitle: '',
            reqParams: {},
        };
    },
    methods: {
        async open({ type, rankId, rankName, baseName, baseId, accountDate }, reqParams = {}) {
            this.reqParams = JSON.parse(JSON.stringify(reqParams));
            this.title = type == 1 ? '晋升考核计算' : '维持考核计算';
            this.labelTitle = '要计算的机构';
            this.visible = true;
            this.showPupUp = true;
            this.$refs.form && this.$refs.form.resetFields();
            this.formData.rankId = rankId;
            this.formData.rankName = rankName;
            this.formData.baseName = baseName;
            this.formData.baseId = baseId;
            if (accountDate) {
                this.formData.checkDate = dayjs(accountDate)
                    .format('YYYY-MM-01');
            } else {
                this.formData.checkDate = dayjs()
                    .startOf('month')
                    .format('YYYY-MM-DD');
            }
            await this.getOrg()
            await this.queryCheckTimes();
        },
        getOrg() {
            return new Promise(resolve => {
                this.$http({
                    url: '/buz/baseAssign/listEffectOrgs',
                    type: 'GET',
                    data: {
                        baseId: this.formData.baseId,
                    }
                }).then(res => {
                    this.orgList = res.data;
                    resolve(res.data)
                });
            });
        },
        queryCheckTimes() {
            return new Promise(resolve => {
                this.$http({
                    url: '/buz/userPromotionRecord/queryCheckTimes',
                    type: 'GET',
                    data: {
                        rankId: this.formData.rankId,
                        type: this.type,
                        year: dayjs(this.formData.checkDate).format('YYYY'),
                    }
                }).then(res => {
                    res.data = res.data.map(item => {
                        return dayjs(item).format('YYYY-MM-01');
                    })
                    this.options.disabledDate = (date) => {
                        let tmp = !res.data.some(i => {
                            return dayjs(i).format('MM') == dayjs(date).format('MM')
                        })
                        return tmp;
                    }
                    if (!res.data.includes(dayjs(this.formData.checkDate).format('YYYY-MM-01'))) {
                        console.log('??')
                        this.formData.checkDate = '';
                    }
                    resolve(res.data)
                }).catch(() => {
                    this.formData.checkDate = '';
                })
            });
        },
        getTips() {
            return new Promise(resolve => {
                this.$http({
                    url: '/buz/userPromotionRecord/getTips',
                    type: 'POST',
                    data: {
                        ...this.reqParams,
                        accountDate: dayjs(this.formData.checkDate).format('YYYY-MM'),
                        organizationIds:this.formData.orgIds
                    }
                }).then(res => {
                    if (res.data) {
                        this.$notice.inquiry(res.data).then(() => {
                            resolve(res.data)
                        })
                    } else {
                        resolve('')
                    }
                });
            });
        },
        save() {
            this.$refs.form.validate().then(async isok => {
                if (!isok) {
                    return;
                }
                let data = JSON.parse(JSON.stringify(this.formData));
                data.checkDate = dayjs(data.checkDate).format('YYYY-MM-DD');
                data.type = this.type == 1 ? '1' : '2';
                await this.getTips();
                this.loading = true;
                this.$http({
                    url: '/buz/userPromotionRecord/startCheck',
                    type: 'POST',
                    data
                }).then(res => {
                    this.$Message.success('操作成功');
                    this.loading = false;
                    this.$emit('success');
                    this.visible = false;
                    this.formData = {};
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.my-modal {
    .ivu-form-item {
        margin-bottom: 10px;
        margin-top: 20px;
    }

    .full {
        .ivu-date-picker {
            // width: 100%;
        }
    }

    .ivu-select {
        width: 226px;
    }

    /deep/.ivu-form-item-content {
        flex: 1;
    }

    .form {
        margin-top: 10px;
        margin-bottom: 20px;
    }

    /deep/ {
        .ivu-modal-body {
            padding-top: 0;
        }
    }

    .text {
        display: block;
        font-size: 13px;
        margin-top: 2px;
    }
}
</style>
